function requireEnv(key: keyof ImportMetaEnv): string {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(
      `Missing required env var ${key}. ` +
        `Locally: add it to .env.local. ` +
        `In CI: add it as a GitHub Actions repo secret and reference it in firebase-deploy.yml.`
    );
  }
  return value;
}

export const env = {
  firebase: {
    apiKey: requireEnv('VITE_FIREBASE_API_KEY'),
    authDomain: requireEnv('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: requireEnv('VITE_FIREBASE_PROJECT_ID'),
    storageBucket: requireEnv('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: requireEnv('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: requireEnv('VITE_FIREBASE_APP_ID'),
  },
  contact: {
    primary: import.meta.env['VITE_CONTACT_EMAIL_PRIMARY'] ?? 'kckernen@gmail.com',
    secondary: import.meta.env['VITE_CONTACT_EMAIL_SECONDARY'] ?? 'satwell@erinind.com',
  },
} as const;
